var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostJobIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.98443 20.5C1.44247 20.5 0.990311 20.3188 0.627958 19.9565C0.265605 19.5941 0.0840363 19.1416 0.083252 18.5988V3.57765C0.083252 3.03569 0.264821 2.58353 0.627958 2.22118C0.991095 1.85882 1.44286 1.67725 1.98325 1.67647H12.9338V2.85294H1.98443C1.80325 2.85294 1.63698 2.92823 1.4856 3.07882C1.33423 3.22941 1.25894 3.39569 1.25972 3.57765V18.6C1.25972 18.7804 1.33502 18.9463 1.4856 19.0976C1.63619 19.249 1.80208 19.3243 1.98325 19.3235H17.0068C17.1872 19.3235 17.3531 19.2482 17.5044 19.0976C17.6558 18.9471 17.7311 18.7812 17.7303 18.6V7.64941H18.9068V18.6C18.9068 19.1412 18.7256 19.5933 18.3633 19.9565C18.0009 20.3196 17.5483 20.5008 17.0056 20.5H1.98443ZM5.37737 16.3823V15.2059H13.6127V16.3823H5.37737ZM5.37737 12.8529V11.6765H13.6127V12.8529H5.37737ZM5.37737 9.32353V8.14706H13.6127V9.32353H5.37737ZM16.5538 6.38235V4.02941H14.2009V2.85294H16.5538V0.5H17.7303V2.85294H20.0833V4.02941H17.7303V6.38235H16.5538Z",
    fill: "#4A4949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostJobIcon);
export default __webpack_public_path__ + "static/media/postJobIcon.6a300ddae5f3d483db38becbd5fd555f.svg";
export { ForwardRef as ReactComponent };